import { object, string, ref } from 'yup';
import HttpStatus from 'http-status-codes';

export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    email: 'Email already exists'
  }
};

export default object().shape({
  email: string()
    .email('Please enter a valid email')
    .required('Please enter your email'),

  password: string()
    .required('Please enter a password')
    .min(6, 'Choose a password 6 digits or longer'),

  passwordConfirmation: string()
    .oneOf([ref('password'), null], 'The specified passwords do not match')
    .required('Please confirm your password')
});
